import { Session } from './types'
import { RootState } from 'lib/core/data/reducer'

const getSlice = (state: any): Session => {
  return state.auth.session
}

export const getIsLoggedIn = (state: RootState): boolean => {
  const session = getSlice(state)
  return !!session.data?.email
}

export const getIsInitialized = (state: RootState) => {
  const session = getSlice(state)
  return session.init
}
